import { createContext, useContext, useState } from "react";

const OverFlowContext = createContext();

export const OverFlowProvider = ({ children }) => {
  const [overflow, setOverflow] = useState(true);

  return (
    <OverFlowContext.Provider value={{ overflow, setOverflow }}>
      {children}
    </OverFlowContext.Provider>
  );
};

export const useOverFlow = () => useContext(OverFlowContext);

export default OverFlowContext;
